<template>
    <div>
        <topnav @tosearch="tosearch" :keywords="keyword" :toptype="toptype" types="1" :isSearch="path"></topnav>
        <div class="" style="background: #f4f4f4;">
            <div class="bg-white response">
                <div class="marginauto conwidth topall" style="width: 1090px;">
                    <div class="nav-view flex justify-start align-center" style="margin-top: 20px;" v-if="cart1_list.length">
                        <div class="" style="color: #959595;font-size: 16px;margin-right: 15px;line-height: 37px;width: 80px;">分类:</div>
                        <div class="nav-item flex justify-start align-center flex-wrap">
                            <div class="topone pointer" v-for="(item,index) in cart1_list" :key="index" :class="item.id == sortIndex ? 'active':''" @click="changSortIndex(index) ">{{item.name}}</div>
                        </div>
                    </div>
                    <div class="nav-view flex justify-start align-center" style="margin-top: 20px;" v-if="cart2_list.length">
                        <div class="" style="color: #959595;font-size: 16px;margin-right: 15px;line-height: 37px;width: 80px;">服务类型:</div>
                        <div class="nav-item flex justify-start align-center flex-wrap">
                            <div class="topone pointer" v-for="(item,index) in cart2_list" :key="index" :class="index == cart2_current ? 'active':''" @click="cart2_current=index">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="marginauto conwidth" style="width: 1130px;">
                <div class="flex-sub flex align-start flex-wrap rightall" :class="list.length ? 'justify-start': 'justify-center'">
                    <div v-for="(item,index) in list" :key="index" @click="todetail(item.id)" class="bg-white lione mthree" style="margin-bottom: 10px;">
                        <div class="lcon">
                            <div class="text-cut ctext1">{{item.name}}</div>
                            <div class="text-cut2 ctext2">{{item.title}}</div>
                            <!-- <div class="text-cut ctext3">服务商：{{item.company}}</div> -->
                            <div class="text-cut ctext3" style="height:26px;"></div>
                            <div class="flex justify-between align-center margin-top">
                                <div class="dbtn">详情</div>
                                <div class="ctext4">咨询{{item.question_number}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="" v-if="!list.length && !load">
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                </div>
                <div class="text-center" style="padding-top: 40px;">
                    <el-pagination background layout="prev, pager, next" :pager-count="pagerCount" :hide-on-single-page="true" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :total="totalnum">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import nomore from "../components/nomore.vue";
export default {
    components: { nomore },
    data() {
        return {
            toptype: 4,
            load: true,
            list: [],
            type: "",
            pagesize: 10,
            totalnum: 0,
            currentPage: 1,
            pagerCount: 7,
            sortIndex: 0,
            sortlist: [],
            path: "/risklist",
            keyword: "",
            cart1_list: [],
            cart1_current: 0,
            cart2_list: [],
            cart2_current: 0,
        };
    },
    watch: {
        sortIndex() {
            this.changCart2();
        },
        cart2_current() {
            this.search();
        },
    },
    computed: {
        first_id() {
            if (this.cart1_list.length > 0 && this.cart1_current != -1) {
                return this.cart1_list[this.cart1_current].id;
            } else {
                return 0;
            }
        },
        second_id() {
            if (this.cart2_list.length > 0 && this.cart2_current != -1) { 
                return this.cart2_list[this.cart2_current].id;
            } else {
                return 0;
            }
        },
    },
    methods: {
        changSortIndex(e){
            let data=this.cart1_list[e];
            this.sortIndex=data.id;
            this.cart1_current=e
        },
        getservicelist() {
            const that = this;
            this.$api.user
                .getservicelist({
                    type: this.sortIndex,
                })
                .then((response) => { 
                    that.cart1_list = response.data;
                    that.cart2_current = 0;
                    that.changCart2();
                });
        },
        changCart2() {
            const that = this; 
            if (that.cart1_list.length > 0) {
                    let list = [
                        { 
                            id: 0,
                            name: "全部", 
                        },
                    ];
                that.cart2_list = list.concat(that.cart1_list[that.cart1_current].list);
            } else {
                that.cart2_list = []; 
            }
            that.cart2_current = 0;
            this.search();
        },
        todetail(e) {
            this.$router.push({ path: "/riskdetail", query: { id: e } });
        },
        handleSizeChange() {},
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getstartlist();
        },
        tabchange(e) {
            this.sortIndex = e;
            this.cart1_current = 0;
            this.cart2_current = 0;
            this.search();
        },
        search() {
            this.list = [];
            this.load = true;
            this.totalnum = 0;
            this.getstartlist();
        },
        tosearch(data) {
            console.log(data);
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.sortIndex = 0;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getstartlist();
        },
        getstartlist() {
            var data = {
                start: this.currentPage,
                page_size: this.pagesize,
                type:this.second_id,
                first_id: this.sortIndex,
                keyword: this.keyword,
            };
            this.$api.index.tech_list(data).then((response) => {
                this.list = response.data;
                this.totalnum = response.count;
                this.load = false;
            });
        },
    },
    created() {
        this.sortIndex = this.$route.query.type;
        this.getservicelist();
        if (this.$route.query.keyword) {
            this.keyword = this.$route.query.keyword;
            this.list = [];
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.sortIndex = 0;
            this.getstartlist();
        } else {
            this.getstartlist();
        }
    },
};
</script>
<style scoped>
.mthree {
    margin-bottom: 10px;
}
.lione {
    border-radius: 3px;
    width: 350px;
    height: 244px;
    margin: 0 10px;
}
.rightall {
    padding: 15px 5px;
    min-height: 498px;
}
.lcon {
    margin: 30px 30px 0 30px;
}
.ctext1 {
    color: #262626;
    font-size: 21px;
    margin-bottom: 12px;
}
.ctext2 {
    color: #9c9c9c;
    font-size: 20px;
    height: 52px;
    margin-bottom: 15px;
}
.ctext3 {
    color: #262626;
    font-size: 20px;
}
.ctext4 {
    color: #bbbbbb;
    font-size: 17px;
}
.dbtn {
    width: 120px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: #fff;
    background-color: #ffab18;
    border-radius: 4px;
    font-size: 18px;
}
.topall {
    padding: 45px 0;
}
.topone {
    padding: 8px 18px;
    font-size: 16px;
    color: #4e4e4e;
}
.active {
    background-color: #ebf8ff;
    border-radius: 4px;
    color: #1759d8;
}
.nav-view {
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// risklist.vue?58823bf0